import React, { useContext, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateContext } from '../context/dateProvider';
import dayjs from 'dayjs';

const DialogDatesSelecter = ({ openDateModal, setOpenDateModal, setShowData }) => {
    const { startDate, endDate, setCustomDerivedDates } = useContext(DateContext);
    const [activeView, setActiveView] = useState('día'); // día | semana | mes
    const [currentDate, setCurrentDate] = useState(endDate);
    const [previousDate, setPreviousDate] = useState(endDate.subtract(1, 'day'));

    const [currentWeek, setCurrentWeek] = useState([endDate.subtract(6, 'day'), endDate]);
    const [previousWeek, setPreviousWeek] = useState([endDate.subtract(13, 'day'), endDate.subtract(7, 'day')]);

    const rangeDiff = endDate.diff(startDate, 'day') + 1;
    const extendedMinDate = startDate.subtract(rangeDiff, 'day'); // si diff = 0, que sea 1 día
    
    const hasDateErrors = () => {
        if (activeView === 'día') {
            return (
                !currentDate || !previousDate ||
                currentDate.isSame(previousDate, 'day') ||
                currentDate.isBefore(extendedMinDate) || currentDate.isAfter(endDate) ||
                previousDate.isBefore(extendedMinDate) || previousDate.isAfter(endDate)
            );
        }

        if (activeView === 'semana') {
            return (
                !currentWeek[1] || !previousWeek[1] ||
                currentWeek[1].isSame(previousWeek[1])
            );
        }

        return false;
    };

    const getDateErrorProps = (date) => ({
        error: !!date && (date.isBefore(extendedMinDate) || date.isAfter(endDate)),
        helperText:
            !!date && (date.isBefore(extendedMinDate) || date.isAfter(endDate))
                ? 'La fecha está fuera del rango permitido.'
                : ''
    });

    // useEffect(() => {
    //     if (openDateModal) {
    //         setCurrentDate(endDate);
    //     }
    // },[openDateModal]);

    return (
        <Dialog open={openDateModal} onClose={() => setOpenDateModal(false)} fullWidth maxWidth="sm">
            <DialogTitle>Seleccionar periodo por {activeView}</DialogTitle>
            <DialogContent>
                <ToggleButtonGroup
                    value={activeView}
                    exclusive
                    onChange={(e, newView) => newView && setActiveView(newView)}
                    sx={{ mb: 2 }}
                    fullWidth
                >
                    <ToggleButton value="día">Por día</ToggleButton>
                    {rangeDiff >= 4 && (
                        <ToggleButton value="semana">Por semana</ToggleButton>
                    )}
                </ToggleButtonGroup>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {activeView === 'día' && (
                        <>
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <DatePicker
                                    label="Fecha actual"
                                    value={currentDate}
                                    onChange={(newValue) => setCurrentDate(newValue)}
                                    minDate={extendedMinDate}
                                    maxDate={endDate}
                                    format='DD/MM/YYYY'
                                    shouldDisableDate={(date) => {
                                        return date.isBefore(extendedMinDate) || date.isAfter(endDate);
                                    }}
                                    sx={{ mb: 2, width: '100%' }}
                                    slotProps={{
                                        textField: {
                                            ...getDateErrorProps(currentDate)
                                        }
                                    }}
                                />
                                <DatePicker
                                    label="Fecha previa"
                                    value={previousDate}
                                    onChange={(newValue) => setPreviousDate(newValue)}
                                    minDate={extendedMinDate}
                                    maxDate={endDate}
                                    format='DD/MM/YYYY'
                                    shouldDisableDate={(date) => {
                                        return date.isBefore(extendedMinDate) || date.isAfter(endDate);
                                    }}
                                    sx={{ mb: 2, width: '100%' }}
                                    slotProps={{
                                        textField: {
                                            ...getDateErrorProps(previousDate)
                                        }
                                    }}
                                />
                            </div>
                            {currentDate && previousDate && currentDate.isSame(previousDate, 'day') && (
                                <div style={{ color: 'red', fontSize: '0.85rem', marginTop: '0.5rem' }}>
                                    Las fechas actual y previa no pueden ser iguales.
                                </div>
                            )}
                        </>
                    )}

                    {activeView === 'semana' && (
                        <>
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                    <DatePicker
                                        label="Fin semana actual"
                                        value={currentWeek[1]}
                                        onChange={(date) => {
                                            const end = dayjs(date);
                                            const start = end.subtract(6, 'day');
                                            setCurrentWeek([start, end]);
                                        }}
                                        minDate={extendedMinDate}
                                        maxDate={endDate}
                                        format='DD/MM/YYYY'
                                        shouldDisableDate={(date) => {
                                            return date.isBefore(extendedMinDate) || date.isAfter(endDate);
                                        }}
                                        sx={{ width: '100%' }}
                                        slotProps={{
                                            textField: {
                                                ...getDateErrorProps(currentWeek[1])
                                            }
                                        }}
                                    />
                                    {currentWeek[0] && currentWeek[1] && (
                                        <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.3rem' }}>
                                            Semana actual: {currentWeek[0].format('DD/MM/YYYY')} – {currentWeek[1].format('DD/MM/YYYY')}
                                        </div>
                                    )}
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                    <DatePicker
                                        label="Fin semana previa"
                                        value={previousWeek[1]}
                                        onChange={(date) => {
                                            const end = dayjs(date);
                                            const start = end.subtract(6, 'day');
                                            setPreviousWeek([start, end]);
                                        }}
                                        minDate={extendedMinDate}
                                        maxDate={endDate}
                                        format='DD/MM/YYYY'
                                        shouldDisableDate={(date) => {
                                            return date.isBefore(extendedMinDate) || date.isAfter(endDate);
                                        }}
                                        sx={{ width: '100%' }}
                                        slotProps={{
                                            textField: {
                                                ...getDateErrorProps(previousWeek[1])
                                            }
                                        }}
                                    />
                                    {previousWeek[0] && previousWeek[1] && (
                                        <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.3rem' }}>
                                            Semana previa: {previousWeek[0].format('DD/MM/YYYY')} – {previousWeek[1].format('DD/MM/YYYY')}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {currentWeek[1].isSame(previousWeek[1]) && (
                                <div style={{ color: 'red', fontSize: '0.85rem', marginTop: '0.5rem' }}>
                                    Las fechas actual y previa no pueden ser iguales.
                                </div>
                            )}
                            {currentWeek[0] && currentWeek[0].isBefore(extendedMinDate) && (
                                <div style={{ color: 'red', fontSize: '0.85rem', marginTop: '0.3rem' }}>
                                    El periodo de la semana actual contiene días fuera del periodo del reporte.
                                </div>
                            )}
                            {previousWeek[0] && previousWeek[0].isBefore(extendedMinDate) && (
                                <div style={{ color: 'red', fontSize: '0.85rem', marginTop: '0.3rem' }}>
                                    El periodo de la semana previa contiene días fuera del periodo del reporte.
                                </div>
                            )}

                        </>
                    )}

                </LocalizationProvider>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => setOpenDateModal(false)}>Cancelar</Button>
                <Button
                    onClick={() => {
                        setCustomDerivedDates({
                            today: currentDate.toDate(),
                            yesterday: previousDate.toDate(),
                            startActualWeek: currentWeek[0].toDate(),
                            endActualWeek: currentWeek[1].toDate(),
                            startPreviousWeek: previousWeek[0].toDate(),
                            endPreviousWeek: previousWeek[1].toDate()
                        });
                        setShowData(true);
                        setOpenDateModal(false);
                    }}
                    disabled={hasDateErrors()}
                >
                    Aplicar
                </Button>

            </DialogActions>
        </Dialog>
    )
}

export default DialogDatesSelecter